module.exports = __webpack_public_path__ + "static/media/card.f5381d44.jpg";